// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"122":"240eccfd","206":"b6dd10c8","295":"bc1a48b1","297":"b0a4e1e9","488":"4b16e567","617":"e92e9157","686":"b1d5706a","831":"beae50fc","950":"e58cfdd3"}[chunkId] + ".chunk.js";
};